import { convertCSVtoArray } from '~/core/utils';
import { formatDateStringForDatePicker } from '~/core/utils/date';
import { SmartProfileInformationResponse } from '~/hooks/api/useGetSmartProfileInformation';

export const transformSmartProfileRespToFieldValueObj = (
  inputObj: SmartProfileInformationResponse,
) => {
  const { id: _, ...fieldsWithStatus } = inputObj;

  const obj = {
    ...fieldsWithStatus,
    verticals: {
      ...fieldsWithStatus.verticals,
      value: convertCSVtoArray(fieldsWithStatus.verticals.value),
    },
    dateOfBirth: {
      ...fieldsWithStatus.dateOfBirth,
      value: formatDateStringForDatePicker(fieldsWithStatus.dateOfBirth.value),
    },
  };

  return Object.fromEntries(
    Object.entries(obj)
      .filter(([, value]) => value.status === 'done')
      .map(([key, value]) => [key, value.value]),
  );
};
